import React from 'react';
import { CheckCircle2, AlertCircle, Clock } from 'lucide-react';
import type { SaveState } from './types';

// ── Autosave indicator ────────────────────────────────────────────────────────

export default function SaveIndicator({ state }: { state: SaveState }) {
  if (state === 'idle') return null;
  const map: Record<Exclude<SaveState, 'idle'>, { icon: React.ReactNode; label: string; color: string }> = {
    saving: { icon: <Clock size={11} />, label: 'Salvataggio…', color: 'var(--color-text-faint)' },
    saved:  { icon: <CheckCircle2 size={11} />, label: 'Salvato', color: 'var(--color-success)' },
    error:  { icon: <AlertCircle size={11} />, label: 'Errore', color: 'var(--color-danger)' },
  };
  const { icon, label, color } = map[state as Exclude<SaveState, 'idle'>];
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 3,
      fontSize: 10, color, flexShrink: 0,
    }}>
      {icon} {label}
    </span>
  );
}
